"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var List_1 = __importDefault(require("@mui/material/List"));
var ListGrouping = __importStar(require("./M_ListGrouping"));
var ListItem = __importStar(require("./M_ListItem"));
var Component = function (props) {
    return (Preact.h(Box_1.default, { bgcolor: "background.default", borderRadius: "8px", sx: __assign({ paddingBottom: '6px', marginY: '16px' }, props.sx) },
        Preact.h(List_1.default, { sx: { paddingY: 0 } },
            Preact.h(Preact.Fragment, null,
                Preact.h(ListGrouping.Component, { subheader: props.subheader, price: props.price, originalPrice: props.originalPrice, savings: props.savings }),
                props.items.map(function (i) { return (Preact.h(ListItem.Component, { imageUrl: i.imageUrl, productName: i.productName, productPrice: i.productPrice, originalPrice: i.originalPrice })); })))));
};
exports.Component = Component;
